export enum RestructureTypeEnum {
  OPEN = 'OPEN',
  PENDING = 'PENDING',
  REFERBACK = 'REFERBACK',
  VOID = 'VOID',
  APPROVED = 'APPROVED',
}
